var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParkingSpace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5461_16682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4682 5.42966H24.8542V7.32257H25.2983C25.7139 7.32257 26.0246 7.24018 26.2309 7.07684C26.4387 6.91205 26.5415 6.67289 26.5415 6.35934C26.5415 6.04143 26.4548 5.80809 26.2812 5.65716C26.1091 5.50476 25.8386 5.42966 25.4682 5.42966Z",
    fill: "#241F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5434 0.671112H18.8657V14.3488H32.5434V0.671112ZM27.2643 7.88549C26.8341 8.24934 26.2245 8.43163 25.4341 8.43163H24.8544V10.6993H23.5018V4.32132H25.5383C26.312 4.32132 26.9011 4.4883 27.3029 4.8208C27.7061 5.1533 27.9067 5.65059 27.9067 6.31049C27.9067 6.99663 27.693 7.52163 27.2643 7.88549Z",
    fill: "#241F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.831 16.3642H33.7625C33.7355 16.3628 33.7071 16.3555 33.6786 16.3555H32.4471C32.4186 16.3555 32.3931 16.3628 32.3647 16.3642H31.5327H30.7335V18.0697V18.4868H28.4294H28.1844H7.29885L9.1451 14.0637L11.2859 9.02152L11.3596 8.85746H17.0332V7.03308H10.0092V7.06808L9.15093 9.04194L5.12666 18.0661C5.12666 17.9691 5.11354 17.8758 5.09749 17.7832H5.10041V16.3555H4.15687H3.41312H2.18083H0.467285V20.0837H4.02416L4.16343 20.1049V20.5022V20.8617V27.2521V27.414V29.2216V29.6642V31.2757H5.36874V33.6097V34.5146V35.2438H10.5495V33.6097H10.5458V31.3778H25.3384V34.1231V34.5146V35.2438H30.517V34.5146V34.1231V31.2487C30.5199 31.2472 30.5213 31.2458 30.5243 31.2451H31.5896V29.6642V29.4214V27.414V27.2521V21.0914V20.5022V20.1224H35.3936V16.3642H33.831Z",
    fill: "#241F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5461_16682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(0.430176 0.457458)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingSpace);
export default __webpack_public_path__ + "static/media/parking-space.c038dea8ec8ab8832419a57f182bf88e.svg";
export { ForwardRef as ReactComponent };